////////////////////////////////////////////////////////////
// constants
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const API_KEY = 'ec5d7dd6-f680-40a4-bc15-1070a7f3cb54';
export const TIMEOUT_SEC = 10;
export const RESULTSPERPAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
export const MODAL_RESET_SEC = 1;